import { render, staticRenderFns } from "./OpportunityDetail.vue?vue&type=template&id=9d89ed36&"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports